"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _VRR6XSK3cjs = require('../__chunks/VRR6XSK3.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-bar-store.ts
var _react = require('react');
function useMenuBarStoreProps(store, update, props) {
  return _VRR6XSK3cjs.useMenubarStoreProps.call(void 0, store, update, props);
}
function useMenuBarStore(props = {}) {
  _react.useEffect.call(void 0, () => {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "useMenuBarStore is deprecated. Use useMenubarStore instead.",
        "See https://ariakit.com/reference/use-menubar-store"
      );
    }
  }, []);
  return _VRR6XSK3cjs.useMenubarStore.call(void 0, props);
}



exports.useMenuBarStore = useMenuBarStore; exports.useMenuBarStoreProps = useMenuBarStoreProps;
